export const activityImageFieldCopy = {
  previewAlt: "Náhled šablony slev",
  pickerLabel: "Nahrát obrázek",
  dragHint: "nebo sem přetáhněte soubor",
  constraints: "min. 500×500, max 5 MB",
  dropHere: "Pusťte obrázek sem",
  replace: "Nahradit",
  remove: "Odstranit",
  uploadFailed: "Nahrání selhalo",
  onlyFirstFileTaken: "Přetáhli jste víc souborů, nahráli jsme první z nich.",
  notAFile: "Přetáhněte prosím soubor s obrázkem.",
} as const;
